import styled from "styled-components";
import { UnSizedButton } from ".";

const SizedButton = styled(UnSizedButton)`
  width: 50%;
`;

export default SizedButton;
